'use strict';

import $ from 'jquery';
import intlTelInput from '../../static/static/plugins/int-tel-input/js/intlTelInput.min.js';

class Order {

  constructor(){
    this.$form = $('#create-order-form');

    if( this.$form.length ){
      this.$phoneCheckbox = $('input[name="tickets_to_phone"]');
      this.animationDuration = 300;
      this.phoneVisibleEl = document.querySelector('#phone-visible-only');
      this.phoneHiddenEl = document.querySelector('input[name="phone"]');
      this.utilsLocation = this.$form ? this.$form.data('utils-location') : null;
      this.stageLang = $(document.body).data('stage-loc') || 'fi';
      this.$phoneErrorEl = $(this.phoneVisibleEl).closest('.group').find('.error');
      this.phoneValidationErrors = {
        'fi': ['Virheellinen numero', 'Virheellinen maakoodi', 'Numero liian lyhyt', 'Numero liian pitkä', 'Virheellinen numero'],
        'en_US': ['Invalid number', 'Invalid country code', 'Too short', 'Too long', 'Invalid number']
      }
    }
  } // constructor

  /**
   * Attach events to DOM elements
   *
   * @memberof Order
   */
  attachEvents(){
    const parent = this;

    // setup intlTelInput
    if( this.phoneVisibleEl && this.phoneHiddenEl ){

      const intTelInputSettings = {
        utilsScript: this.$form.data('studio') + 'static/plugins/int-tel-input/js/utils.js',
        preferredCountries: ['fi','us'],
        nationalMode: true,
        autoPlaceholder: 'off'
      };

      intlTelInput(this.phoneVisibleEl,intTelInputSettings);
      parent.iti = window.intlTelInputGlobals.getInstance(this.phoneVisibleEl);

      $(this.phoneVisibleEl).on('change keyup countrychange',function(e){
        parent.processPhoneField();
      });

    }

    // email input: only lowercase letters
    $(document.body).on('change keyup','input[name="email"]',function(e){
      const value = $(e.target).val();
      if( value ) $(e.target).val(value.toLowerCase());
    });

    // Form submit
    this.$form.on('submit',function(e){
      if( !parent.processPhoneField() ) {
        e.preventDefault();
      }
      // disable double submit
      $(':submit', this).attr('disabled', 'disabled');
    });

  } // attachEvents




  /**
 * Process phone field
 * - validates visible phone field's value (user submitted),
 * - populates hidden phone field with internationalized version of phone number
 * - toggles error classes for visible field if field value is not valid
 * @returns {boolean} true if ok for submit, otherwise false
 * @memberof Order
 */
  processPhoneField(){


    const visibleField = this.phoneVisibleEl,
      hiddenField = this.phoneHiddenEl,
      visibleFieldValue = $(visibleField).val(),
      visibleFieldValid = visibleFieldValue ? this.iti.isValidNumber() : (visibleFieldValue ? false : true), // note: empty value is ok
      errorCode = !visibleFieldValid ? this.iti.getValidationError() : null,
      internationalPhoneNumber = visibleFieldValid ? this.iti.getNumber() : '';

    if( !visibleFieldValid ) {
      $(visibleField).toggleClass('error',true);
      const errorText = this.phoneValidationErrors[this.stageLang][errorCode];
      this.$phoneErrorEl.html(errorText);
    }
    else {
      $(visibleField).toggleClass('error',false);
      this.$phoneErrorEl.html('');
    }

    $(hiddenField).val(internationalPhoneNumber);

    return visibleFieldValid;
  }

  /**
   * Check if order form exists and attach events if necessary
  */
  init(){
    console.log('order.init()');
    if( this.$form.length ) {
      this.attachEvents();
    }
  }

}

export default new Order();
